export const signUpES = {
  header: 'Registrarse',
  register: 'REGISTRARSE'
}
